// Anexo original da tabela de frete (PO1-2857 / PO1-2859) — endpoints do backend_hub
// entregues na H1 (PO1-2858). Usar `api` (API_URL), não `ApiHubBackend`.
//
//   GET    /frete/tabelas/:id/anexos               → Anexo[]
//   POST   /frete/tabelas/:id/anexos               → { anexos } (multipart, campo "anexos", até 5 × 10 MB)
//   GET    /frete/tabelas/:id/anexos/:idAnexo/url  → { url, expiraEm, nome, formato, contentType } (URL pré-assinada, 15 min)
//   DELETE /frete/tabelas/:id/anexos/:idAnexo      → { ok: true }
//
// Anexo = { id, idFreteTabela, nome, formato, contentType, tamanho, origem: "UPLOAD"|"REAJUSTE",
//           idFreteTabelaOrigem, creationTime, creatorUserId }
//
// O interceptor de services/api.js remove o Content-Type quando o body é FormData e injeta o
// header X-Active-Embarcador-Id; por isso não se passa header manual aqui.
import api from "./api";

export const ANEXO_TABELA_EXTENSOES = ["pdf", "xls", "xlsx", "xlsm", "msg", "eml"];
export const ANEXO_TABELA_ACCEPT = ANEXO_TABELA_EXTENSOES.map((e) => "." + e).join(",");
export const ANEXO_TABELA_MAX_ARQUIVOS = 5;
export const ANEXO_TABELA_MAX_BYTES = 10 * 1024 * 1024;
export const ANEXO_TABELA_LEGENDA =
  "PDF, XLS/XLSX/XLSM, MSG ou EML · até 5 por envio · 10 MB cada";

export function extensaoDe(nome) {
  const partes = String(nome || "").split(".");
  if (partes.length < 2) return "";
  const ultimo = String(partes[partes.length - 1] || "");
  return /^[A-Za-z0-9]{1,10}$/.test(ultimo) ? ultimo.toLowerCase() : "";
}

// Validação client-side antes de qualquer request (mesmas regras do backend).
export function validarArquivosAnexo(fileList) {
  const arquivos = Array.from(fileList || []);
  const validos = [];
  const erros = [];

  if (!arquivos.length) {
    erros.push("Nenhum arquivo selecionado.");
    return { validos, erros };
  }
  if (arquivos.length > ANEXO_TABELA_MAX_ARQUIVOS) {
    erros.push(`No máximo ${ANEXO_TABELA_MAX_ARQUIVOS} arquivos por envio.`);
    return { validos, erros };
  }

  arquivos.forEach((arquivo) => {
    const nome = (arquivo && arquivo.name) || "(sem nome)";
    const ext = extensaoDe(nome);
    if (ANEXO_TABELA_EXTENSOES.indexOf(ext) === -1) {
      erros.push(
        `Tipo não permitido: ${nome}. Aceitos: ${ANEXO_TABELA_EXTENSOES.join(", ")}.`
      );
      return;
    }
    if (!arquivo.size) {
      erros.push(`Arquivo vazio: ${nome}.`);
      return;
    }
    if (arquivo.size > ANEXO_TABELA_MAX_BYTES) {
      erros.push(`Arquivo acima de 10 MB: ${nome}.`);
      return;
    }
    validos.push(arquivo);
  });

  return { validos, erros };
}

export async function listarAnexos(idTabela) {
  const { data } = await api.get(`/frete/tabelas/${idTabela}/anexos`);
  return Array.isArray(data) ? data : [];
}

export async function enviarAnexos(idTabela, files) {
  const form = new FormData();
  Array.from(files || []).forEach((f) => form.append("anexos", f, f.name));
  const { data } = await api.post(`/frete/tabelas/${idTabela}/anexos`, form);
  return (data && Array.isArray(data.anexos) && data.anexos) || [];
}

export async function obterUrlAnexo(idTabela, idAnexo) {
  const { data } = await api.get(`/frete/tabelas/${idTabela}/anexos/${idAnexo}/url`);
  return data;
}

export async function excluirAnexo(idTabela, idAnexo) {
  const { data } = await api.delete(`/frete/tabelas/${idTabela}/anexos/${idAnexo}`);
  return data;
}

export function mensagemErroAnexo(error, fallback) {
  const status = error && error.response && error.response.status;
  const payload = error && error.response && error.response.data;
  const doBackend =
    payload && typeof payload === "object"
      ? (typeof payload.error === "string" && payload.error) ||
        (typeof payload.message === "string" && payload.message) ||
        ""
      : typeof payload === "string"
        ? payload
        : "";

  if (status === 503) return "Storage de anexos não configurado no servidor. Avise o suporte.";
  if (status === 404) return "Tabela não encontrada no seu escopo.";
  if (status === 403) return doBackend || "Você não tem acesso aos anexos desta tabela.";
  if (status === 413) return "Arquivo acima do limite de 10 MB.";
  return doBackend || (error && error.message) || fallback || "Não foi possível concluir a operação.";
}

export function rotuloOrigem(anexo) {
  if (!anexo || anexo.origem !== "REAJUSTE") return "";
  return anexo.idFreteTabelaOrigem
    ? `Herdado do reajuste (tabela #${anexo.idFreteTabelaOrigem})`
    : "Herdado do reajuste";
}
